import React from 'react';
import './bodas.css';
import FormularioBeneficio from './FormularioBeneficio';
import MarcoBoho from './MarcoBoho';
import { C, ColoresReservados, Divisor, Eyebrow, PieMarca, Redes, WhatsAppFlotante, retraso } from './LandingPartes';
import { bodasApi, mensajeWhatsApp, textoBeneficio, waLink } from './bodasUtils';

const BotonReservar = ({ style }) => (
  <div className="boda-anim mt-8" style={style}>
    <a href="#registro-invitados" className="boda-boton w-full sm:w-auto sm:min-w-[280px]" data-testid="landing-reservar">
      Reservar mi beneficio
    </a>
  </div>
);

const Parrafo = ({ children, style, className = '' }) => (
  <p className={`boda-anim boda-sans mx-auto max-w-[34rem] text-[1.0625rem] leading-[1.7] sm:text-lg ${className}`} style={{ color: C.suave, ...style }}>{children}</p>
);

const Condiciones = ({ condiciones, vigencia }) => (condiciones || vigencia) ? (
  <p className="boda-anim boda-sans mx-auto mt-10 max-w-md text-[0.9375rem] leading-relaxed" style={{ color: C.suave, ...retraso(1.4) }} data-testid="landing-condiciones">
    {condiciones}{condiciones && vigencia ? ' · ' : ''}{vigencia ? `Vigencia: ${vigencia}` : ''}
  </p>
) : null;

const Nombres = ({ children, style }) => (
  <h1 className="boda-anim-name mt-4 text-balance break-words text-[clamp(2.5rem,11vw,5rem)] font-semibold leading-[1.04]" style={{ color: C.tinta, ...style }} data-testid="landing-nombres">
    {children}
  </h1>
);

const CajaBeneficio = ({ titulo, texto, detalle, style }) => (
  <div className="boda-anim mx-auto mt-8 max-w-md rounded-md border px-5 py-6 sm:px-7" style={{ borderColor: 'rgba(122,84,24,0.35)', background: '#F4EEDF', ...style }}>
    <Eyebrow style={{ color: C.oroTexto }}>{titulo}</Eyebrow>
    <p className="mt-2 text-[clamp(1.6rem,6vw,2.3rem)] font-semibold leading-tight" style={{ color: C.tinta }} data-testid="landing-beneficio">{texto}</p>
    {detalle && <p className="boda-sans mt-2 text-base leading-relaxed" style={{ color: C.suave }}>{detalle}</p>}
  </div>
);

const bienvenida = (marca) => [
  'Nos emociona pensar que pronto daremos el «sí» rodeados de las personas que queremos. Al imaginar ese día, pensamos en los abrazos, las risas y la alegría de celebrar contigo el comienzo de una nueva etapa en nuestra historia.',
  'Tu presencia significa mucho para nosotros. Queremos que disfrutes esta celebración, que te sientas parte de ella y que juntos creemos recuerdos que nos acompañen toda la vida.',
  `Por eso, junto a ${marca}, hemos preparado un beneficio especial para ti. Es un detalle de nuestra parte para compartir la ilusión desde los preparativos y agradecerte por acompañarnos en un día que guardaremos siempre en el corazón.`,
];

const fotoPareja = (d) => d.foto_url || (d.foto_version ? bodasApi.urlFotoPareja(d.slug, d.foto_version) : null);

const FotoPareja = ({ d }) => {
  const foto = fotoPareja(d);
  if (!foto) return null;
  return (
    <div className="mb-11 mt-12 sm:mb-12 sm:mt-14">
      <MarcoBoho src={foto} encuadre={d.foto_encuadre} alt={`${d.persona_a} y ${d.persona_b}`} style={retraso(0.7)} />
    </div>
  );
};

const HeroBoda = ({ d, marca }) => (
  <section>
    <Eyebrow style={retraso(0.45)}>Bienvenidos a la boda de</Eyebrow>
    <Nombres style={retraso(0.6)}>
      {d.persona_a}<span className="mx-2 align-middle font-normal italic sm:mx-3" style={{ color: C.oroTexto }}>&amp;</span>{d.persona_b}
    </Nombres>
    <FotoPareja d={d} />
    <div className="my-7 sm:my-8"><Divisor style={retraso(0.8)} /></div>
    <div className="space-y-5 sm:space-y-6" data-testid="landing-bienvenida">
      {bienvenida(marca).map((texto, i) => <Parrafo key={i} style={retraso(0.9 + i * 0.05)}>{texto}</Parrafo>)}
    </div>
    {d.beneficio_valor && (
      <>
        <CajaBeneficio titulo="Tu beneficio como invitado" texto={textoBeneficio(d.beneficio_tipo, d.beneficio_valor)} detalle={d.beneficio_aplica} style={retraso(1)} />
        <BotonReservar style={retraso(1.1)} />
      </>
    )}
  </section>
);

const DetallesBoda = ({ d }) => {
  const colores = d.colores || [];
  if (!d.fecha_texto && !d.codigo_vestuario && !colores.length) return null;
  return (
    <>
      <div className="my-12 sm:my-14"><Divisor style={retraso(1.2)} /></div>
      {d.fecha_texto && (
        <section className="boda-anim" style={retraso(1.25)} data-testid="landing-fecha">
          <Eyebrow>Fecha</Eyebrow>
          <p className="mt-2 text-[clamp(1.5rem,5vw,2rem)] font-semibold" style={{ color: C.tinta }}>{d.fecha_texto}</p>
        </section>
      )}
      {d.codigo_vestuario && (
        <section className="boda-anim mt-11" style={retraso(1.3)} data-testid="landing-vestuario">
          <Eyebrow>Código de vestuario</Eyebrow>
          <p className="mt-2 text-[clamp(1.6rem,5.5vw,2.3rem)] font-semibold leading-tight" style={{ color: C.tinta }}>{d.codigo_vestuario}</p>
          {d.indicaciones_vestuario && <p className="boda-sans mx-auto mt-3 max-w-md text-base leading-relaxed sm:text-[1.0625rem]" style={{ color: C.suave }}>{d.indicaciones_vestuario}</p>}
        </section>
      )}
      {colores.length > 0 && <ColoresReservados colores={colores} style={retraso(1.35)} />}
    </>
  );
};

const HeroReferido = ({ d, marca }) => (
  <section>
    <Eyebrow style={retraso(0.45)}>Una invitación de</Eyebrow>
    <Nombres style={retraso(0.6)}>{d.nombre_referente}</Nombres>
    <div className="my-7 sm:my-8"><Divisor style={retraso(0.8)} /></div>
    <Parrafo style={retraso(0.9)}>{d.nombre_referente?.split(' ')[0]} confía en {marca} para vestir a la medida y quiere compartir contigo un beneficio exclusivo.</Parrafo>
    <CajaBeneficio titulo="Tu beneficio" texto={d.beneficio_texto} detalle={d.beneficio_aplica} style={retraso(1)} />
    <BotonReservar style={retraso(1.1)} />
  </section>
);

const ContactoDirecto = ({ waHref }) => waHref ? (
  <p className="boda-sans mx-auto mt-7 max-w-md text-base leading-relaxed" style={{ color: C.suave }}>
    ¿Prefieres escribirnos directamente?{' '}
    <a href={waHref} target="_blank" rel="noopener noreferrer" className="boda-enlace" data-testid="landing-whatsapp-link">Escríbenos por WhatsApp</a>
  </p>
) : null;

export default function LandingBeneficio({ variante = 'boda', datos, contacto, borrador = false, avisoBorrador, vistaPrevia = false, sinAnimacion = false }) {
  const marca = contacto?.marca_nombre || 'Juan Pablo Murillo';
  const esReferido = variante === 'referido';
  const waHref = waLink(contacto?.whatsapp, mensajeWhatsApp(variante, datos, contacto));
  const codigo = esReferido ? datos.codigo : datos.slug;
  const mensaje = esReferido
    ? `Déjanos tus datos para recibir asesoría personalizada y aplicar tu ${datos.beneficio_valor}% de descuento en tu primera compra.`
    : 'Déjanos tus datos para recibir asesoría personalizada y aplicar el beneficio especial de esta boda.';

  return (
    <main id="main-content" className={`boda-landing relative min-h-screen w-full overflow-x-hidden ${sinAnimacion ? 'boda-sin-animacion' : ''}`}
      style={{ color: C.tinta, backgroundColor: C.fondo }} data-testid="landing-beneficio-page">
      {borrador && (
        <div className="boda-sans sticky top-0 z-30 w-full px-4 py-2 text-center text-xs font-semibold uppercase tracking-[0.18em]" style={{ background: C.tinta, color: C.superficie }} data-testid="landing-aviso-borrador">
          {avisoBorrador || 'Vista previa · Borrador no publicado'}
        </div>
      )}
      <div className="boda-marco mx-auto w-full max-w-[760px] md:max-w-[940px]" style={{ '--boda-fondo': "url('/img/bodas/acuarela-marco.webp')" }}>
        <div aria-hidden className="boda-velo" />
        <div className="boda-hoja text-center" data-testid="landing-hoja">
          {esReferido ? <HeroReferido d={datos} marca={marca} /> : <HeroBoda d={datos} marca={marca} />}
          {!esReferido && <DetallesBoda d={datos} />}
          <Condiciones condiciones={datos.beneficio_condiciones} vigencia={datos.beneficio_vigencia} />
          <section id="registro-invitados" className="boda-anim mt-14 scroll-mt-6" style={retraso(1.45)}>
            <Divisor />
            <div className="mt-10">
              <FormularioBeneficio endpoint={bodasApi.registroUrl(variante, codigo)} waHref={waHref} contacto={contacto} vistaPrevia={vistaPrevia}
                titulo={esReferido ? 'Reclama tu beneficio' : 'Haz parte de esta celebración'} mensaje={mensaje} />
            </div>
            <ContactoDirecto waHref={waHref} />
          </section>
          <Redes redes={contacto?.redes} style={retraso(1.55)} />
          <PieMarca marca={marca} style={retraso(1.65)} />
        </div>
      </div>
      <WhatsAppFlotante href={waHref} />
    </main>
  );
}
